/* eslint-disable react/prop-types */

import React, { useState, useEffect } from 'react';
import HashtagTable from './hashtag_table';

function FollowedHashtagsTable({
  follows,
  handleFollow,
  handleMute,
  handleBlock,
  handleRemoveForceFollow,
  hashtagUsageCeiling,
}) {
  const [localFollows, setLocalFollows] = useState(follows);

  // Update local state when props change (e.g., when switching tabs)
  useEffect(() => {
    setLocalFollows(follows);
  }, [follows]);

  // Handlers that update local state for immediate feedback
  const onFollow = (id, isHighVolume) => {
    setLocalFollows((prev) => prev.map((item) => (
      item.hashtag_id === id ? { ...item, follow_status: 'follow' } : item
    )));
    handleFollow('MatchFeed::Hashtag', id, isHighVolume);
  };

  const onMute = (id) => {
    setLocalFollows((prev) => prev.map((item) => (
      item.hashtag_id === id ? { ...item, follow_status: 'mute' } : item
    )));
    handleMute('MatchFeed::Hashtag', id);
  };

  const onRemoveForceFollow = (id) => {
    setLocalFollows((prev) => prev.map((item) => (
      item.hashtag_id === id ? { ...item, force_followed_at: null } : item
    )));
    handleRemoveForceFollow('MatchFeed::Hashtag', id);
  };

  const onBlock = (id) => {
    setLocalFollows((prev) => prev.map((item) => (
      item.hashtag_id === id ? { ...item, follow_status: 'block' } : item
    )));
    handleBlock('MatchFeed::Hashtag', id);
  };

  return (
    <HashtagTable
      hashtags={localFollows}
      hashtagUsageCeiling={hashtagUsageCeiling}
      onFollow={onFollow}
      onMute={onMute}
      onBlock={onBlock}
      onRemoveForceFollow={onRemoveForceFollow}
    />
  );
}

export default FollowedHashtagsTable;
